export default __webpack_public_path__ + "static/KY2-9bb7dfc3469732467e59b04a001d4b6f.png";